export default "__VITE_ASSET__CRL2sCfb__"